

// Section visibility detection - ONLY handles .visible-section class management
document.addEventListener('DOMContentLoaded', function() {
    // Function to detect when sections are visible and add/remove .visible-section class
    function initSectionVisibilityDetection() {
        const sections = document.querySelectorAll('.shopify-section');
        
        if (sections.length === 0) return;
        
        // Create intersection observer for section visibility
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const section = entry.target;
                
                if (entry.isIntersecting) {
                    // Section is visible - add visible class
                    section.classList.add('visible-section');
                } else {
                    // Section is not visible - remove visible class
                    section.classList.remove('visible-section');
                }
            });
        }, {
            threshold: 0.3, // Trigger when 30% of section is visible
            rootMargin: '0px'
        });
        
        // Observe all sections
        sections.forEach(section => {
            sectionObserver.observe(section);
        });
    }
    
    // Initialize the section visibility detection
    initSectionVisibilityDetection();
});

// Debug: Get user's country code when page loads
console.log('Getting user country code...');
fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {
        console.log('=== USER LOCATION DEBUG ===');
        console.log('Full location data:', data);
        console.log('Country code:', data.country_code);
        console.log('Country name:', data.country_name);
        console.log('City:', data.city);
        console.log('Region:', data.region);
        console.log('IP:', data.ip);
        console.log('===========================');
    })
    .catch(error => {
        console.log('Error getting location:', error);
    });

// Refer menu redirect functionality
document.addEventListener('click', function(e) {
    console.log('Something clicked:', e.target);
    
    const link = e.target.closest('a');
    if (!link) return;
    
    console.log('Link found:', {
        id: link.id,
        href: link.href,
        text: link.textContent.trim()
    });
    
    // Check if this is the Refer menu link
    if (link.id === 'HeaderMenu-refer' && link.href.includes('/pages/share')) {
        console.log('*** REFER LINK CLICKED ***');
        e.preventDefault(); // Prevent default navigation temporarily
        
        // Get user's country using IP geolocation
        fetch('https://ipapi.co/json/')
            .then(response => response.json())
            .then(data => {
                console.log('User location data:', data);
                const userCountry = data.country_code;
                
                // If user is not from US, redirect to Australian site
                if (userCountry && userCountry !== 'US') {
                    console.log('User is not from US, redirecting to Australian site');
                    window.location.href = 'https://renuebyscience.com.au/pages/share';
                } else {
                    console.log('User is from US, allowing normal navigation');
                    window.location.href = link.href;
                }
            })
            .catch(error => {
                console.log('Error detecting location, allowing normal navigation:', error);
                // If geolocation fails, allow normal navigation
                window.location.href = link.href;
            });
    } else {
        console.log('Not the refer link, ignoring');
    }
});
